import React from 'react';
import { Spin } from 'antd';
import styled, { css } from 'styled-components';
import { COLORS } from '../../utils/constants';

interface SpinnerProps {
  size?: 'large' | 'default' | 'small';
  color?: string;
  fullScreen?: boolean;
  tip?: string;
  minHeight?: number;
}

const Spinner: React.FC<SpinnerProps> = ({
  size = 'default',
  color,
  fullScreen = false,
  tip,
  minHeight,
}) => {
  if (fullScreen) {
    return (
      <FullScreenWrapper minHeight={minHeight}>
        <StyledSpin size={size} color={color} tip={tip} />
      </FullScreenWrapper>
    );
  }

  return <StyledSpin size={size} color={color} tip={tip} />;
};

const FullScreenWrapper = styled.div<{ minHeight?: number }>`
  background: ${COLORS.white.primary};
  z-index: 1000;
  min-height: ${({ minHeight }) => (minHeight ? `${minHeight}px` : 'auto')};
  display: flex;
  justify-content: center;
  align-items: center;

  .ant-spin {
    .ant-spin-text {
      margin-top: 8px;
      color: ${COLORS.blue.primary};
    }
  }
`;

const StyledSpin = styled(Spin)<{ color?: string }>`
  ${({ color }) =>
    color &&
    css`
      .ant-spin-dot-item {
        background-color: ${color};
      }
    `}
`;

export default Spinner;
